import { Navigation } from "../../interfaces/Navigation";
import { PermissionMenuName } from "../../interfaces/UserRole";

const navPengaturan: Navigation = {
  title: 'Pengaturan',
  items: [
    {
      title: "User Control",
      route: "/user-control",
      icon: "fa fa-users",
      permissionId: PermissionMenuName.userControl
    },
    {
      title: "User Role",
      route: "/user-role",
      icon: "fa fa-gears",
      permissionId: PermissionMenuName.userRole
    },
  ]
};

export default navPengaturan;